export interface Campaign {
  id: string;
  name: string;
  message_text: string;
  link_url: string | null;
  status: 'rascunho' | 'agendada' | 'ativa' | 'pausada' | 'finalizada' | 'cancelada';
  total_contacts: number;
  sent_count: number;
  delivered_count: number;
  read_count: number;
  replied_count: number;
  failed_count: number;
  scheduled_at: string | null;
  started_at: string | null;
  completed_at: string | null;
  target_groups: string[];
  target_type: 'grupos' | 'segmento' | 'todos';
  media_type: 'image' | 'video' | 'audio' | 'document' | null;
  media_url: string | null;
  message_variants: string[] | null;
  daily_limit: number | null;
  created_at: string;
  updated_at: string;
}

export const campaignStatuses = [
  { value: 'rascunho', label: 'Rascunho', color: 'bg-secondary-100 text-secondary-800 border-secondary-200' },
  { value: 'agendada', label: 'Agendada', color: 'bg-accent-100 text-accent-800 border-accent-200' },
  { value: 'ativa', label: 'Ativa', color: 'bg-primary-100 text-primary-800 border-primary-200' },
  { value: 'pausada', label: 'Pausada', color: 'bg-amber-50 text-amber-700 border-amber-200' },
  { value: 'finalizada', label: 'Finalizada', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  { value: 'cancelada', label: 'Cancelada', color: 'bg-red-50 text-red-700 border-red-200' },
];

export function getStatusConfig(status: string) {
  return campaignStatuses.find((s) => s.value === status) ?? campaignStatuses[0];
}

export const mockCampaigns: Campaign[] = [
  {
    id: 'cmp-001',
    name: 'Black Friday 2024',
    message_text: 'A Black Friday chegou na nossa loja! Aproveite até 50% OFF. Válido por tempo limitado!',
    status: 'finalizada',
    total_contacts: 1250,
    sent_count: 1250,
    delivered_count: 1180,
    read_count: 945,
    replied_count: 312,
    failed_count: 70,
    scheduled_at: '2024-11-29T08:00:00Z',
    started_at: '2024-11-29T08:00:00Z',
    completed_at: '2024-11-29T10:30:00Z',
    target_groups: ['Clientes VIP', 'Leads Quentes'],
    target_type: 'grupos',
    media_type: null,
    media_url: null,
    created_at: '2024-11-20T14:00:00Z',
    updated_at: '2024-11-29T10:30:00Z',
  },
  {
    id: 'cmp-002',
    name: 'Campanha de Ano Novo',
    message_text: 'Feliz Ano Novo! Agradecemos por fazer parte da nossa história. Desconto especial de 15% para você!',
    status: 'agendada',
    total_contacts: 2100,
    sent_count: 0,
    delivered_count: 0,
    read_count: 0,
    replied_count: 0,
    failed_count: 0,
    scheduled_at: '2025-01-01T00:00:00Z',
    started_at: null,
    completed_at: null,
    target_groups: ['Todos os Contatos'],
    target_type: 'todos',
    media_type: 'image',
    media_url: 'https://picsum.photos/800/600',
    created_at: '2024-12-15T09:00:00Z',
    updated_at: '2024-12-15T09:00:00Z',
  },
  {
    id: 'cmp-003',
    name: 'Promoção de Verão',
    message_text: 'O verão está chegando e as ofertas também! Confira nossos lançamentos com frete grátis.',
    status: 'ativa',
    total_contacts: 850,
    sent_count: 420,
    delivered_count: 410,
    read_count: 320,
    replied_count: 85,
    failed_count: 10,
    scheduled_at: '2024-12-20T10:00:00Z',
    started_at: '2024-12-20T10:00:00Z',
    completed_at: null,
    target_groups: ['Segmento Sul'],
    target_type: 'segmento',
    media_type: 'video',
    media_url: 'https://www.w3schools.com/html/mov_bbb.mp4',
    created_at: '2024-12-18T11:30:00Z',
    updated_at: '2024-12-20T10:15:00Z',
  },
  {
    id: 'cmp-004',
    name: 'Lembrete de Pagamento',
    message_text: 'Olá, lembramos que seu pagamento está próximo do vencimento. Evite juros e pague com facilidade.',
    status: 'rascunho',
    total_contacts: 340,
    sent_count: 0,
    delivered_count: 0,
    read_count: 0,
    replied_count: 0,
    failed_count: 0,
    scheduled_at: null,
    started_at: null,
    completed_at: null,
    target_groups: ['Inadimplentes'],
    target_type: 'grupos',
    media_type: null,
    media_url: null,
    created_at: '2024-12-22T16:00:00Z',
    updated_at: '2024-12-22T16:00:00Z',
  },
  {
    id: 'cmp-005',
    name: 'Campanha de Reativação',
    message_text: 'Sentimos sua falta! Voltamos com novidades incríveis. Que tal uma oferta exclusiva de boas-vindas de volta?',
    status: 'pausada',
    total_contacts: 560,
    sent_count: 200,
    delivered_count: 190,
    read_count: 150,
    replied_count: 30,
    failed_count: 10,
    scheduled_at: '2024-12-10T08:00:00Z',
    started_at: '2024-12-10T08:00:00Z',
    completed_at: null,
    target_groups: ['Clientes Inativos'],
    target_type: 'grupos',
    media_type: null,
    media_url: null,
    created_at: '2024-12-05T10:00:00Z',
    updated_at: '2024-12-12T09:00:00Z',
  },
  {
    id: 'cmp-006',
    name: 'Lançamento Produto X',
    message_text: 'Novidade chegando! Apresentamos o Produto X, desenvolvido especialmente para você. Peça já o seu!',
    status: 'cancelada',
    total_contacts: 1500,
    sent_count: 0,
    delivered_count: 0,
    read_count: 0,
    replied_count: 0,
    failed_count: 0,
    scheduled_at: '2024-11-15T09:00:00Z',
    started_at: null,
    completed_at: null,
    target_groups: ['Early Adopters'],
    target_type: 'grupos',
    media_type: 'image',
    media_url: 'https://picsum.photos/800/600',
    created_at: '2024-11-01T08:00:00Z',
    updated_at: '2024-11-10T10:00:00Z',
  },
  {
    id: 'cmp-007',
    name: 'Agradecimento Fim de Ano',
    message_text: 'Obrigado por fazer parte da nossa jornada em 2024. Desejamos um 2025 incrível para você e sua família!',
    status: 'finalizada',
    total_contacts: 3000,
    sent_count: 3000,
    delivered_count: 2950,
    read_count: 2400,
    replied_count: 890,
    failed_count: 50,
    scheduled_at: '2024-12-30T18:00:00Z',
    started_at: '2024-12-30T18:00:00Z',
    completed_at: '2024-12-30T20:00:00Z',
    target_groups: ['Todos os Contatos'],
    target_type: 'todos',
    media_type: null,
    media_url: null,
    created_at: '2024-12-25T10:00:00Z',
    updated_at: '2024-12-30T20:00:00Z',
  },
  {
    id: 'cmp-008',
    name: 'Campanha de Referência',
    message_text: 'Indique um amigo e ganhe benefícios exclusivos! Ambos ganham desconto na próxima compra.',
    status: 'rascunho',
    total_contacts: 0,
    sent_count: 0,
    delivered_count: 0,
    read_count: 0,
    replied_count: 0,
    failed_count: 0,
    scheduled_at: null,
    started_at: null,
    completed_at: null,
    target_groups: ['Clientes Ativos'],
    target_type: 'grupos',
    media_type: null,
    media_url: null,
    created_at: '2024-12-28T09:00:00Z',
    updated_at: '2024-12-28T09:00:00Z',
  },
];